import React from "react";
import { Avatar, AvatarProps } from "@UI/Components/Avatar/Avatar";
import { Icon } from "@UI/Components/Icon/Icon";
import { ICandidate } from "@modules/ServiceRequest/types";
import { SuperTalentBadgeWithWhiteBorder } from "@UI/Components/Icons/SuperTalentBadge";

const sizes = {
  avatar: { s: "50px", md: "74px", lg: "150px" },
  icon: { s: "20px", md: "20px", lg: "40px" },
};

export const CandidateAvatar = (
  props: {
    url: string;
    size?: "s" | "md" | "lg";
    isSuperTalent: ICandidate["superTalent"];
  } & AvatarProps
) => {
  const { url, size = "md", isSuperTalent, ...rest } = props;
  return (
    <Avatar
      w={sizes.avatar[size]}
      h={sizes.avatar[size]}
      src={url}
      position="relative"
      {...rest}
    >
      {isSuperTalent && (
        <Icon
          as={SuperTalentBadgeWithWhiteBorder}
          position="absolute"
          bottom="0"
          right="0"
          w={sizes.icon[size]}
          h={sizes.icon[size]}
        />
      )}
    </Avatar>
  );
};
